import type { RootState } from 'src/redux/store'

export const selectPaymentProcess = (state: RootState): PaymentProcess.PaymentProcess =>
  state['@paymentProcess']
